import _objectSpread from "/data/jenkins/workspace/wyt-admin/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, isRef as _isRef, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-cdbced14"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "add-role"
};

const _hoisted_2 = /*#__PURE__*/_createTextVNode("取消");

const _hoisted_3 = /*#__PURE__*/_createTextVNode("确认");

import { computed, nextTick, ref, watch } from 'vue';
import { getMenuTree, getAppMenuTree, addRole } from '@/request';
import { ElMessage } from 'element-plus';
import { useStore } from 'vuex';
export default {
  name: 'AddRoleModal',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    editData: {
      type: [null, Object],
      default: null
    }
  },
  emits: ['update:modelValue', 'success'],

  setup(__props, {
    emit
  }) {
    const props = __props;
    const store = useStore();
    const paramRoleType = store.state.user.userType === 1 ? 2 : 1; // roleStatus: 1
    // roleType: 2
    // appResourceIds:
    // pcResourceIds: 15,16,17,18,14
    // roleName: 测试橘色2
    // roleId:
    // roleDesc: 奥术大师多

    const form = ref({
      roleName: '',
      roleDesc: '',
      roleType: paramRoleType,
      roleStatus: 1,
      pcResourceIds: ''
    });
    const treeRef = ref();
    const formRef = ref();
    const menuTree = ref([]);
    const visible = computed({
      get() {
        return props.modelValue;
      },

      set(val) {
        emit('update:modelValue', val);
      }

    });

    function getCheckedNodeKeys(data) {
      let result = [];
      data.forEach(item => {
        if (item.checked) {
          result.push(item.id);
        }

        if (item.children.length) {
          result = result.concat(getCheckedNodeKeys(item.children));
        }
      });
      return result;
    }

    const getMenu = store.state.user.userType === 1 ? getMenuTree : getAppMenuTree;
    watch(() => props.modelValue, newVal => {
      if (newVal && !props.editData) {
        var _formRef$value, _treeRef$value;

        form.value = {
          roleName: '',
          roleDesc: '',
          roleType: paramRoleType,
          roleStatus: 1,
          pcResourceIds: ''
        }; // 打开窗口 重置表单

        (_formRef$value = formRef.value) === null || _formRef$value === void 0 ? void 0 : _formRef$value.resetFields(); // 重置选中菜单

        (_treeRef$value = treeRef.value) === null || _treeRef$value === void 0 ? void 0 : _treeRef$value.setCheckedKeys([]);
      } else if (props.editData) {
        // 编辑 查询菜单配置 会返回 已选中的菜单
        let initForm = _objectSpread(_objectSpread({}, form.value), props.editData);

        form.value = initForm; // 获取已选中的菜单

        getMenu({
          roleId: props.editData.roleId,
          resourceType: 3
        }).then(data => {
          if (data) {
            treeRef.value.setCheckedKeys(getCheckedNodeKeys(data));
          }
        });
      }
    }, {
      flush: 'post'
    });
    getMenu({
      resourceType: 3
    }).then(data => {
      if (data) {
        menuTree.value = data;
      }
    });

    function confirm() {
      formRef.value.validate(result => {
        if (result) {
          form.value.pcResourceIds = [...treeRef.value.getCheckedKeys(), ...treeRef.value.getHalfCheckedKeys()].join(',');

          const {
            roleName,
            roleDesc,
            roleType,
            roleStatus,
            pcResourceIds,
            roleId
          } = _objectSpread(_objectSpread({}, form.value), {}, {
            __repeat: true,
            __warn: true
          }); // roleStatus: 1
          // roleType: 2
          // appResourceIds:
          // pcResourceIds: 15,16,17,18,14
          // roleName: 测试角色
          // roleId: 12
          // roleDesc: 描述22


          addRole({
            roleName,
            roleDesc,
            roleType,
            roleStatus,
            pcResourceIds,
            roleId,
            __repeat: true,
            __warn: true
          }, {
            params: {
              roleType: paramRoleType
            }
          }).then(data => {
            if (data.success) {
              visible.value = false;
              ElMessage({
                showClose: true,
                message: '操作成功',
                type: 'success'
              });
              emit('success');
            }
          });
        }
      });
    }

    function selectMenu(aa) {}

    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");

      const _component_el_form_item = _resolveComponent("el-form-item");

      const _component_el_col = _resolveComponent("el-col");

      const _component_el_row = _resolveComponent("el-row");

      const _component_el_form = _resolveComponent("el-form");

      const _component_el_tree = _resolveComponent("el-tree");

      const _component_el_scrollbar = _resolveComponent("el-scrollbar");

      const _component_el_button = _resolveComponent("el-button");

      const _component_el_dialog = _resolveComponent("el-dialog");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_dialog, {
        modelValue: _unref(visible),
        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => _isRef(visible) ? visible.value = $event : null),
        title: __props.editData ? '编辑角色' : '新增角色',
        width: "800px"
      }, {
        footer: _withCtx(() => [_createVNode(_component_el_button, {
          onClick: _cache[2] || (_cache[2] = $event => visible.value = false)
        }, {
          default: _withCtx(() => [_hoisted_2]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: confirm
        }, {
          default: _withCtx(() => [_hoisted_3]),
          _: 1
        })]),
        default: _withCtx(() => [_createVNode(_component_el_form, {
          ref_key: "formRef",
          ref: formRef,
          model: form.value
        }, {
          default: _withCtx(() => [_createVNode(_component_el_row, {
            gutter: 20
          }, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "角色名称:",
                prop: "roleName",
                disabled: "",
                rules: {
                  required: true,
                  message: '请填写角色名称'
                }
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: form.value.roleName,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => form.value.roleName = $event),
                  placeholder: ""
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "角色描述:",
                prop: "roleDesc",
                rules: {
                  required: true,
                  message: '请填写角色描述'
                }
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: form.value.roleDesc,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => form.value.roleDesc = $event),
                  placeholder: ""
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }, 8, ["model"]), _createVNode(_component_el_form_item, {
          label: "菜单配置:"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_scrollbar, {
            class: "tree-wrap",
            height: "300px",
            style: {
              "width": "100%"
            }
          }, {
            default: _withCtx(() => [_createVNode(_component_el_tree, {
              data: menuTree.value,
              "show-checkbox": "",
              ref_key: "treeRef",
              ref: treeRef,
              "node-key": "id",
              props: {
                label: 'text',
                children: 'children'
              },
              onCheck: selectMenu,
              "check-strictly": false
            }, null, 8, ["data"])]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }, 8, ["modelValue", "title"])]);
    };
  }

};